module.exports = __webpack_public_path__ + "static/observers-579b102b8db008810e113304f48f042b.svg";